import axios from 'axios';

// Create a new instance of Axios
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production'
    ? '/api/'
    : 'http://127.0.0.1:8000/', // Default to local backend for development
  timeout: 20000, // Allow for serverless cold starts in production
  headers: {
    'Content-Type': 'application/json',
    // 'Authorization': `Bearer ${authToken}`,
  },
});

export default api;
